<template>
  <div class="container ">
    <div class="breadcrumb-list">
      <ol class="breadcrumb">
        <li aria-current="page" class="breadcrumb-item active">Projects</li>
      </ol>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-4">
            <label>Customer Name</label>
            <multiselect
              v-model="search.cName"
              tag-placeholder="Search customer"
              placeholder="Search customer"
              label="name"
              track-by="name"
              :options="customerOptions"
              :multiple="false"
              :max-height="200"
            >
            </multiselect>
          </div>
          <div class="col-4">
            <label>Project Name</label>
            <input class="form-control" v-model="search.pName" placeholder="Write Something ..."
                   style="border-color: #C4C4C4 !important;">
          </div>
          <div class="col-4">
            <label>Project Admin</label>
            <multiselect
              v-model="search.admins"
              tag-placeholder="Search an Admin"
              placeholder="Search an Admin"
              label="name"
              track-by="name"
              group-values="employee"
              group-label="role"
              :options="adminOptions"
              :multiple="true"
              :max-height="200"
            >
            </multiselect>
          </div>
          <div class="col-12 mt-10">
            <button class="btn btn-primary col-1" @click="getProjects">Search</button>
            <button class="btn btn-light col-1" @click="resetSearchForm">Reset</button>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-30 mb-5">
      <div class="col-12 text-right">
        <button v-if="showDeleteButton" class="btn btn-danger col-1" @click="deleteProjects">Delete</button>
        <router-link to="/timesheet/project" tag="button" class="btn btn-primary col-1">Add</router-link>
      </div>
    </div>
    <div class="card">
      <div class="card-body p-0">
        <table class="table table-striped">
          <thead>
          <th>
            <input type="checkbox" v-model="selectAll">
          </th>
          <th class="text-page">Customer Name</th>
          <th class="text-page">Project Name</th>
          <th class="text-page">Project Admins</th>
          <th class="text-center text-page">Actions</th>
          </thead>
          <tbody>
          <tr v-for="project in projects">
            <td>
              <div class="form-check">
                <input class="form-check-input" v-model="selected" type="checkbox" :value="project.id">
              </div>
            </td>
            <td class="text-page">{{ project.customer.name }}</td>
            <td class="text-page">{{ project.name }}</td>
            <td class="text-page">
                <span v-for="admin in project.admins" class="badge badge-light ml-5">
                  {{ admin.name }}
                </span>
            </td>
            <td class="text-center">
              <router-link :to="'/timesheet/project/'+project.id" tag="span" class="ico-pencil text-primary" style="cursor: pointer;"></router-link>
            </td>
          </tr>
          <tr v-if="!projects.length">
            <td colspan="5" class="text-center text-page">No data found.</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<style scoped>
.table tr {
  border: none !important;
}

.table td:first-child {
  width: 20px !important;
}

.table thead {
  background-color: #E9E9E9 !important;
}

.table thead th {
  border: none !important;
}

.table-striped > tbody > tr:nth-child(odd) > td,
.table-striped > tbody > tr:nth-child(odd) > th {
  background-color: #F7F7F7;
}

.text-page{
  font-size: 15px !important;
}

body {
  font-family: "Lato", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji" !important;
}
input[type=text]{
  border-color: rgb(196, 196, 196) !important;
}
</style>
<script>
import Multiselect from "vue-multiselect";
import Header from "../common/header";
import Swal from "sweetalert2";

export default {
  name: "timesheetProjects",
  components: {
    Header,
    Multiselect,
    Swal
  },
  data() {
    return {
      company_id: this.$store.getters.getSelectedCompany.id,
      projects: [],
      modalTitle: "Add Project",
      selectedAdmins: [],
      selectedCustomer: null,
      customerOptions: [],
      adminOptions: [],
      pName: null,
      selected: [],
      search: {
        cName: null,
        pName: null,
        admins: []
      }
    }
  },
  computed: {
    selectAll: {
      get: function () {
        return this.projects ? this.selected.length == this.projects.length : false;
      },
      set: function (value) {
        var selected = [];
        if (value) {
          this.projects.forEach(function (user) {
            selected.push(user.id);
          });
        }
        this.selected = selected;
        //console.log(this.selected);
      },
    },
    showDeleteButton() {
      return this.selected.length > 0;
    }
  },
  mounted() {
    this.getProjects();
    this.getCustomers();
    this.getAdmins();
  },
  methods: {
    // load all projects for this company
    getProjects() {
      let admins = null;
      if(this.search.admins != null){
        admins = [];
        this.search.admins.forEach(function (admin){
          admins.push(admin.id);
        });
      }
      let params = {
        company_id: this.company_id,
        customer_id: (this.search.cName == null)?null:this.search.cName.id,
        admins: admins,
        name: this.search.pName
      };

      this.$axios.get(this.$GetProjects, {
        params: params,
        headers: this.getAuthHeader(),
      }).then(res => {
        if (res.data.status === 200) {
          this.projects = res.data.result;
        }
      });
    },

    // get customers for add/edit project
    getCustomers() {
      let params = {
        company_id: this.company_id
      };

      this.$axios.get(this.$GetCustomers, {
        params: params,
        headers: this.getAuthHeader(),
      }).then(res => {
        if (res.data.status === 200) {
          let customerData = [];
          res.data.result.forEach(function (customer) {
            customerData.push({
              id: customer.id,
              name: customer.name
            });
          });
          this.customerOptions = customerData;
        }
      });
    },

    // get admins for add/edit project
    getAdmins() {
      let params = {
        company_id: this.company_id,
        filter_by: 'job_role'
      };

      this.$axios.get(this.$GetAdmins, {
        params: params,
        headers: this.getAuthHeader(),
      }).then(res => {
        if (res.data.status === 200) {
          let adminData = [];
          res.data.result.employees.forEach(function (admin) {
            let admins = [];
            admin.list.forEach(function (user) {
              admins.push({
                name: user.name,
                id: user.id
              });
            });
            adminData.push({
              role: admin.key,
              employee: admins
            });
          });
          this.adminOptions = adminData;
        }
      });
    },

    // close modal and reset form
    closeModal(){
      this.resetForm();
      $('#projectModal').modal('hide');
    },

    // reset form data
    resetForm(){
      this.pName = null;
      this.selectedCustomer = null;
      this.selectedAdmins = [];
    },

    // submit form
    submitForm(){
      let admins = [];
      this.selectedAdmins.forEach(function (admin){
        admins.push(admin.id);
      });
      let formData = {
        name: this.pName,
        status: 1,
        company_id: this.company_id,
        customer_id: (this.selectedCustomer != null)?this.selectedCustomer.id:null,
        admins: admins
      };
      this.$axios.post(this.$AddProject, formData,{
        headers: this.getAuthHeader(),
      }).then(res => {
        if (res.data.status === 200) {
          this.resetForm();
          $('#projectModal').modal('hide');
          this.getProjects();
        }
      });
    },

    editProject(id){
      let project = this.projects.filter(function(item){
        return item.id === id;
      });

      if(project.length > 0){
        this.modalTitle = "Edit Project";
        this.pName = project[0].name;
        this.selectedCustomer = {
          id: project[0].customer.id,
          name: project[0].customer.name
        };
        let admins = [];
        project[0].admins.forEach(function (admin){
          admins.push({
            name: admin.name,
            id: admin.id
          });
        });
        this.selectedAdmins = admins;
        $('#projectModal').modal('show');
      }
    },

    deleteProjects(){
      new Swal({
        title: "Delete Projects?",
        icon: "warning",
        text: "Are you sure? You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, Delete it!"
      }).then((result) => {
        if (result.value) {
          this.$axios.delete(this.$DeleteProject, {
            params: {
              projects: this.selected
            },
            headers: this.getAuthHeader(),
          }).then(res => {
            if (res.data.status === 200) {
              this.getProjects();
              this.selected = [];
              this.selectAll = false;
            }
          });
        }
      });
    },

    resetSearchForm(){
      this.search.cName = null;
      this.search.pName = null;
      this.search.admins = [];
      this.getProjects();
    }
  }
}
</script>
